import React from 'react';
import { motion } from 'framer-motion';
import { ScrollReveal, StaggerContainer, staggerChild } from './ScrollReveal';
import './Services.css';

const services = [
  {
    num: '01',
    title: 'Custom business software',
    desc: 'Bespoke platforms built around your exact operating model — not a template you have to bend yourself around.',
    icon: (
      <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.4">
        <rect x="3" y="4" width="18" height="16" rx="2" />
        <path d="M3 9h18M8 4v5" />
      </svg>
    ),
  },
  {
    num: '02',
    title: 'Process automation',
    desc: 'We map the friction across your operations and automate it end to end — fewer handoffs, fewer manual steps.',
    icon: (
      <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.4">
        <path d="M4 12a8 8 0 0 1 14.9-4M20 12a8 8 0 0 1-14.9 4" />
        <path d="M17 4v4h-4M7 20v-4h4" />
      </svg>
    ),
  },
  {
    num: '03',
    title: 'Systems integration',
    desc: 'Your tools, connected. adap8 links procurement, finance, HR and operations into one cohesive system.',
    icon: (
      <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.4">
        <circle cx="6" cy="6" r="2.4" />
        <circle cx="18" cy="6" r="2.4" />
        <circle cx="12" cy="18" r="2.4" />
        <path d="M8.1 7.2 10 16M15.9 7.2 14 16M8.4 6h7.2" />
      </svg>
    ),
  },
  {
    num: '04',
    title: 'Dashboards & analytics',
    desc: 'Real-time visibility into the metrics that actually run your business, built for the people who use them daily.',
    icon: (
      <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.4">
        <path d="M4 20V10M11 20V4M18 20v-7" />
      </svg>
    ),
  },
  {
    num: '05',
    title: 'Workflow intelligence',
    desc: 'Logic that routes, flags and adjusts as conditions change — built to respond, not just static rule sheets.',
    icon: (
      <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.4">
        <path d="M12 3 3 8l9 5 9-5-9-5ZM3 16l9 5 9-5M3 12l9 5 9-5" />
      </svg>
    ),
  },
  {
    num: '06',
    title: 'Ongoing evolution',
    desc: 'Software that keeps adapting long after launch, as your team, your volume and your business change.',
    icon: (
      <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.4">
        <path d="M12 2v4M12 18v4M4.9 4.9l2.8 2.8M16.3 16.3l2.8 2.8M2 12h4M18 12h4M4.9 19.1l2.8-2.8M16.3 7.7l2.8-2.8" />
      </svg>
    ),
  },
];

function Services() {
  return (
    <section className="sec brushed" id="services">
      <div className="wrap">
        <ScrollReveal>
          <div className="sec-head">
            <div className="eyebrow">WHAT WE BUILD</div>
            <h2>End-to-end solutions for modern operations</h2>
            <p>
              One team, one build, across every layer your operations touch — from the first
              process map to the software your people use every day.
            </p>
          </div>
        </ScrollReveal>

        <StaggerContainer className="services-grid" staggerDelay={0.1}>
          {services.map((service) => (
            <motion.div key={service.num} className="service-card" variants={staggerChild}>
              <span className="num">{service.num}</span>
              <div className="service-icon">{service.icon}</div>
              <h3>{service.title}</h3>
              <p>{service.desc}</p>
            </motion.div>
          ))}
        </StaggerContainer>
      </div>
    </section>
  );
}

export default Services;
